import { gql } from '@apollo/client';
import { ASYNC_TASK_FRAGMENT } from '@/components/AsyncTask';

export const IMPORT_REGULAR_HEALTH_CHECKUP_RESULT_CSV = gql`
  mutation ImportRegularHealthCheckupResultCsv($input: ImportRegularHealthCheckupResultCsvInput!) {
    importRegularHealthCheckupResultCsv(input: $input) {
      client {
        id
        asyncTask {
          ...AsyncTaskFields
        }
      }
    }
  }
  ${ASYNC_TASK_FRAGMENT}
`;

export interface ImportRegularHealthCheckupResultCsvQueryVariables {
  input: {
    file: File;
    mode: 'update' | 'delete';
  };
}
